/**
 * Número de WhatsApp que recibe los leads, en formato internacional
 * (código de país + número, solo dígitos).
 * 1 = Estados Unidos. Cámbialo a '52...' si el número es de México.
 */
export const WHATSAPP_NUMBER = '18127429709'

export const WHATSAPP_DISPLAY = '(812) 742-9709'

export function buildWhatsAppUrl(message: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
}
